import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, MenuController, ModalController, PopoverController } from '@ionic/angular';
import { PedidosPopoverComponent } from 'src/app/components/pedidoPopover/pedidos-popover.component';
import { GlobalConstants } from 'src/app/services/globalConstants/global-constants.service';
import { GlobalFunctionsService } from 'src/app/services/globalFunctions/global-functions.service';
import { StorageService } from 'src/app/services/storage/storage.service';

import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { VentaService } from 'src/app/services/venta/venta.service';
import { VisitaService } from 'src/app/services/visita/visita.service';
import { PedidoDetallePage } from '../pedidoDetalle/pedidoDetalle.page';

@Component({
  selector: 'app-ventas',
  templateUrl: './ventas.page.html',
  styleUrls: ['./ventas.page.scss'],
})
export class VentasPage implements OnInit {

  //#region Propiedades

  public _appVersion: string;

  public _utmCampaign: string = null;
  public _utmContent: string = null;
  public _utmMedium: string = null;
  public _utmSource: string = null;
  public _utmTerm: string = null;
  public _total: number = 0;
  public _mostrarProductos: number = 3;

  public _listVentas: any;

  //#endregion Propiedades

  //#region Constructor

  constructor(private _route: ActivatedRoute,
              private _menuCtrl: MenuController,
              private _usuarioSrv: UsuarioService,
              private _visitaSrv: VisitaService,
              private _ventaSrv: VentaService,
              public _alertController: AlertController,
              private _popoverCtrl: PopoverController,
              public storage: StorageService,
              private _router: Router,
              private _globalFunctionsSrv: GlobalFunctionsService,
              private modalCtrl: ModalController) {

    console.log('CarritoPage >> constructor');
    this._listVentas = [];
  }

  //#endregion Constructor

  //#region Eventos NG

  public ngOnInit() {
    console.log('CarritoPage >> ngOnInit');
    this._menuCtrl.enable(false);
  }

  public async ionViewDidEnter() {

    console.log('CarritoPage >> ionViewDidEnter');

    this._appVersion = GlobalConstants.APP_VERSION;

    // recupera/crea/guarda token publico
    await this._usuarioSrv.doPublicToken();

    // await this._deviceSrv.getLocationInfo();

    /*this._deviceSrv.getLocationInfo().then((domi) => {
      console.log('el domi que se va a mandar es:');
      console.log(domi);
    });*/

    // registra visita
    await this._route.queryParams.subscribe((params) => {

      // recupera datos de UTM
      if (params['utm_campaign'] !== undefined) { this._utmCampaign = params['utm_campaign']; }
      if (params['utm_content'] !== undefined) { this._utmContent = params['utm_content']; }
      if (params['utm_medium'] !== undefined) { this._utmMedium = params['utm_medium']; }
      if (params['utm_source'] !== undefined) { this._utmSource = params['utm_source']; }
      if (params['utm_term'] !== undefined) { this._utmTerm = params['utm_term']; }

      this._visitaSrv.guardar('CarritoCompras', null, null,
        null, null, null, null,
        null, null,
        this._utmCampaign, this._utmContent, this._utmMedium, this._utmSource, this._utmTerm).subscribe();
      this.getAllVentas();
    });
    await this._usuarioSrv.doPublicToken();
  }

  public async getAllVentas(){
    this._ventaSrv.getAllVentas().subscribe(() => {
      console.log('lista de ventas');
      console.log(this._ventaSrv.ventas);
      this._listVentas = this._ventaSrv.ventas;
      if (this._listVentas && this._listVentas.length > 0){
        this._mostrarProductos = 1;
      }
      else{
        this._mostrarProductos = 0;
      }
    });

  }

  public async detailPedido(item){
    const modal = await this.modalCtrl.create({
      component: PedidoDetallePage,
      cssClass: 'modalPedido',
      componentProps: {
        '_productos': item['Productos'],
        '_pedido': item
      }
    });
    modal.present();

    modal.onDidDismiss().then((data) => {
      if (data['data']){
        this.getAllVentas();
      }
    });
  }

  //#endregion

}
